/** 与 admin componentSchema 组件 name 保持一致，供装修预览标注 */
export const DECORATION_TYPE_NAMES = {
  container: '容器',
  title: '标题文字',
  richText: '富文本',
  notice: '通知公告',
  blank: '辅助留白',
  banner: '轮播图',
  imageSingle: '单图',
  imageMulti: '多图',
  video: '视频',
  goodsRecommend: '商品推荐',
  goodsSelection: '商品甄选',
  seckill: '秒杀',
  groupBuy: '拼团',
  coupon: '优惠券',
  searchNav: '搜索导航',
  search: '搜索框',
  categoryNav: '首页分类导航',
  goodsCategory: '商品分类',
  navIconRow: '导航按钮组',
  imageScroll: '滚动图片',
  pageBanner: '页面顶部广告',
  tabs: 'Tab切换',
  brand: '品牌',
  storeRecommend: '店铺推荐',
  hotSelection: '热选爆款',
  footerLinkGroup: '页脚链接组',
  partnerLogoRow: '合作伙伴',
  icpInfo: 'ICP 备案',
  topNavMenu: '顶部导航菜单',
  logoBlock: '站点 Logo',
  searchBox: '搜索框',
  langSwitcher: '语言切换',
  currencySwitcher: '货币切换',
  loginBlock: '登录入口',
  cartIcon: '购物车',
  messageIcon: '消息图标'
}

export function decorationTypeName (type, t) {
  if (t) {
    const key = 'message.home.decoType_' + type
    const v = t(key)
    if (v !== key) return v
  }
  return DECORATION_TYPE_NAMES[type] || type || ''
}
